import createSelector from '../../utils/reselect';

const userStateData = (state) => {
  const { auth } = state;
  return auth || {};
};

export const getUser = createSelector(userStateData, (auth) => {
  const u = auth.get('user') || null;
  if (u) {
    return JSON.parse(JSON.stringify(u));
  }
  return u;
});

export const userId = createSelector(userStateData, (auth) => auth.get('userId'));

export const userRole = createSelector(userStateData, (auth) => auth.get('role'));

export const loginInProgress = createSelector(userStateData, (auth) => auth.get('loading'));

export const error = createSelector(userStateData, (auth) => auth.get('error'));

export const mfaError = createSelector(userStateData, (auth) => auth.get('mfaError'));

export const logo = createSelector(userStateData, (auth) => auth.get('logo'));

export const mfaRequired = createSelector(userStateData, (auth) => auth.get('isMfaRequired'));

export const mfaSetupRequired = createSelector(userStateData, (auth) => auth.get('isMfaSetupRequired'));

export const mfaSetupToken = createSelector(userStateData, (auth) => auth.get('mfaSetupToken'));

export const passwordResetRequired = createSelector(userStateData, (auth) => auth.get('isPasswordResetRequired'));

export const passwordResetToken = createSelector(userStateData, (auth) => auth.get('passwordResetToken'));

export const resetPasswordResponse = createSelector(userStateData, (auth) => auth.get('resetPasswordResponse'));